import React, { Component } from "react";

class HeroImage extends Component {
    render() {
        return (
            <header id="heroProductImage" className="header header-bg-cover-4">
                <div className="overlay"></div>
            </header>
        );
    }
}

export default HeroImage;